module.exports = __webpack_public_path__ + "site-build/img/icon-3.021d1356.svg";